<template>
  <div>
    <vs-popup class="deliverer-modal" title="Urenregistratie" :active.sync="showPopup">

    </vs-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showPopup: false,
      staff: {}
    };
  },

  mounted() {
    this.$events.listen('open-registration-model', () => {
      this.showPopup = true;
    });
  }
};
</script>